function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m50.032 62.659a4.0678 4.0678 0 0 0 0-6.464l-25.101-20.963a4.1318 4.1318 0 0 1 0-6.464l25.101-20.963a4.0678 4.0678 0 0 0 0-6.464 6.2664 6.2664 0 0 0-7.7483 0l-25.101 20.959a12.178 12.178 0 0 0 0 19.396l25.108 20.963a6.2664 6.2664 0 0 0 7.7483 0z",
    fill: "currentColor",
    style: {
      strokeWidth: 1.9371
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallArrowLeft);
export default __webpack_public_path__ + "static/media/small-arrow-left.666d1d3c.svg";
export { ForwardRef as ReactComponent };